/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClearConfigurationRequest
 */
export interface ClearConfigurationRequest {
    /**
     * 
     */
    expected_version: number;
}

/**
 * Check if a given object implements the ClearConfigurationRequest interface.
 */
export function instanceOfClearConfigurationRequest(value: object): value is ClearConfigurationRequest {
    if (!('expected_version' in value) || value['expected_version'] === undefined) return false;
    return true;
}

export function ClearConfigurationRequestFromJSON(json: any): ClearConfigurationRequest {
    return ClearConfigurationRequestFromJSONTyped(json, false);
}

export function ClearConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClearConfigurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_version': json['expected_version'],
    };
}

export function ClearConfigurationRequestToJSON(json: any): ClearConfigurationRequest {
    return ClearConfigurationRequestToJSONTyped(json, false);
}

export function ClearConfigurationRequestToJSONTyped(value?: ClearConfigurationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_version': value['expected_version'],
    };
}

